export const FIELD_TYPES = [
  ["text", "Text"], ["number", "Number"], ["boolean", "Yes / no"], ["date", "Date"],
  ["url", "URL"], ["select", "Dropdown"], ["multi_select", "Multi-select"], ["json", "JSON"],
];

export const DEFAULT_STAGES = "new, researching, qualified, contacted, customer, paused";

export function commaValues(value) {
  return [...new Set(value.split(",").map((item) => item.trim()).filter(Boolean))];
}
